<div class="form-group filter-selection">
  <label for="filterSelection">Filter by</label>
  <mat-form-field appearance="outline" class="filter-form-field">
    <mat-select #filterSelection (selectionChange)="onFilterSelectionChange()"
                id="filterSelection"
                placeholder="Select filter">
      <mat-option *ngFor="let option of options" [value]="option">{{option.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div [ngClass]="{'active': filterSelection?.value}" class="filter-container">
  <div class="d-flex align-items-center mr-2">
    <!-- Text input filter -->
    <div *ngIf="filterSelection?.value?.type === 'text'" class="form-group filter selected">
      <input #text
             (input)="inputEmitter.emit({optionValue: filterSelection?.value?.value, value: $event?.target?.value, type: filterSelection?.value?.type})"
             class="form-control text-input"
             placeholder="Enter filter"
             type="text"
      />
    </div>

    <!-- Date filter -->
    <div *ngIf="filterSelection?.value?.type === 'date'" class="form-group filter selected">
      <mat-form-field appearance="outline" class="filter-form-field date-field">
        <input matInput
          (click)="date.open()"
          (dateChange)="onChange(filterSelection?.value?.value, $event.target.value, filterSelection?.value?.type)"
          [matDatepicker]="date"
          class="calendar-input g-cursor-pointer"
          placeholder="Select date"
          readonly/>
        <mat-datepicker-toggle matIconSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Select/Multi-select filter -->
    <div *ngIf="['select', 'multi-select'].includes(filterSelection?.value?.type)" class="form-group filter selected">
      <mat-form-field appearance="outline" class="filter-form-field">
        <mat-select #select
                    [multiple]="filterSelection?.value?.type === 'multi-select'"
                    (selectionChange)="onChange(filterSelection?.value?.value, $event.value, filterSelection?.value?.type)"
                    placeholder="Select option">
          <mat-option *ngFor="let option of filterSelection?.value?.data"
                      [value]="option.value">{{option.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div (click)="clearFilters()" [ngClass]="{'clearable': filterSelection?.value !== undefined}"
       class="close g-cursor-pointer">
    <i class="material-icons">close</i>
  </div>
</div>
